<div class="container">
  <!-- Site Info Edit -->
  <db-site-info-edit
    *ngIf="!isEditingDescription && isComponentVisible"
    (openDescription)="onOpenDescription()"
    @fadeSlideLeftAnimation>
    <ng-content></ng-content>
  </db-site-info-edit>

  <!-- Site Description Edit -->
  <db-site-description-edit
    *ngIf="isEditingDescription && isComponentVisible"
    (onEvent)="onEvent.emit($event)"
    [website]="website"
    [description]="(builderInteractionsService.siteInfo|async)?.business_description"
    (closeDescription)="onCloseDescription()"
    @fadeSlideAnimation>
  </db-site-description-edit>
</div>
